import { render, staticRenderFns } from "./ChannelsView.vue?vue&type=template&id=0100bda4"
import script from "./ChannelsView.vue?vue&type=script&lang=js"
export * from "./ChannelsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports